// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-user-dialog.common-dialog[data-v-3c00e6ae] .el-dialog{width:var(--common-dialog-width)}", ""]);
// Exports
module.exports = exports;
